import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";

import { Strings } from "../app.constants";
import { ValidityMap } from "../store/validity/state";
import { RootState } from "../store/root";
import { Protocol } from "../data/model";
import { PersistenceService } from "../store/model/persistence.service";
import { stateBuilder } from "../store/utils";

@Component({
    selector: "zbd-occasion",
    templateUrl: "occasion.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccasionComponent {
    state$: Observable<LocalState>;

    Constants = Strings;

    constructor(
        public persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        this.state$ = LocalState.create(store);
    }
}

class LocalState {
    protocol: Protocol;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState()).apply(
            "protocol",
            (s) => s.model.ConsultationProcess.Protocol,
        ).state$;
    }
}
